import { render, staticRenderFns } from "./TmntChampsStat.vue?vue&type=template&id=b31138e4&"
import script from "./TmntChampsStat.vue?vue&type=script&lang=js&"
export * from "./TmntChampsStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports